import React from 'react'
import { compose } from 'ramda'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { change, getFormValues, reduxForm } from 'redux-form'
import axios from 'axios'

import { UIButton, UICheckbox, UIIcon, UILayout, UIText } from 'bora-material-ui'

import { CustomerAccountPayment } from '../CustomerAccountPayment/index'
import { PaymentMethods } from '../PaymentMethods/index'
import TotalPrice from '../TotalPrice'

import UIElements from '../../../../../../../consts/UIElements'
import messages from '../../../../../../../consts/messages'
import { actions, selectors } from '../../../../../provider'
import { Alert } from '../../../../../../../components'
import { THEME } from 'bora-material-ui/themes'
import { goToPage } from '../../../../../../../actions'
import { ListItem, Logo } from '../PaymentMethods/PaymentMethods'
import { getStyle, isLiinilaevad } from '../../../../../../../utils/liinilaevadThemeUtils'
import { PaymentTerms } from './PaymentTerms'
import { getLocale } from '../../../../../../../services/user-selections'

export const DivHTMLParser = ({ node, parent = {} }) =>
  node.children.map((props) => {
    if (props.children) {
      return <DivHTMLParser node={props} parent={props} />
    }

    return parent.name === 'a' ? (
      <a
        target="new"
        align="left"
        href={parent.attribs.href}
        color="rgb(44, 70, 132)"
        style={{
          fontFamily: getStyle('SourceSansPro, Sans-Serif'),
          color: getStyle('#3387CC', 'rgb(44, 70, 132)'),
        }}
      >
        {props.data}
      </a>
    ) : (
      <UIText
        align="left"
        color="black"
        font={getStyle('SourseSansPro, Sans-Serif')}
        {...(window.brandProps.muiTheme.ids.Confirmation &&
          window.brandProps.muiTheme.ids.Confirmation.rowText && {
            ...window.brandProps.muiTheme.ids.Confirmation.rowText,
          })}
      >
        {props.data}
      </UIText>
    )
  })

export const xsStyles = {
  wrapper: { justify: 'around-space', column: true },
  subWrapper: { padding: '0', width: 'auto', maxWidth: '100%' },
  priceWrapper: { padding: '10px 0' },
  termsWrapper: { padding: '0' },
  checkBoxWrapper: { padding: '10px 10px 0 10px' },
  paymentTerms: { padding: '10px' },
  waysWrapper: { padding: '0', width: 'auto', center: true },
  customerPayment: { margin: '16px 0 0 0', width: '100%' },
  button: { width: 'auto', margin: '15px 0 0 0' },
}

export const styles = {
  label: {
    size: getStyle('18px', '22px'),
    fontFamily: getStyle('SourceSansPro, Sans-Serif'),
    color: getStyle('#3387CC'),
    textTransform: getStyle('uppercase'),
    fontWeight: 'bold',
    ...(window.brandProps.muiTheme.ids.Confirmation &&
      window.brandProps.muiTheme.ids.Confirmation.rowText && {
        'font-family': window.brandProps.muiTheme.ids.Confirmation.rowText.font,
      }),
  },
  labelIcon: { marginRight: '10px', fill: getStyle('#B7B7B7', UIElements.FONT_COLOR) },
  termsChildren: { margin: '0 0 5px 0' },
}

function isCreditPaymentAvailable(paymentMethods) {
  return paymentMethods.some((method) => method.creditClient)
}

class Payment extends React.Component {
  static contextTypes = {
    intl: PropTypes.any,
    muiTheme: PropTypes.object,
  }

  static defaultProps = {
    customerRole: {},
    termsAccepted: false,
    editMode: false,
  }

  static propTypes = {
    amount: PropTypes.string.isRequired,
    sailPackageCode: PropTypes.string.isRequired,
    onPaymentClick: PropTypes.func.isRequired,
    changeReduxFormField: PropTypes.func.isRequired,
    termsAccepted: PropTypes.bool,
    paymentMethods: PropTypes.array.isRequired,
    totalPrice: PropTypes.array.isRequired,
    customerRole: PropTypes.object,
    editMode: PropTypes.bool,
  }

  state = {
    paymentStarted: false,
  }

  constructor() {
    super()
    this.handlePaymentClickProxy = this.handlePaymentClickProxy.bind(this)
  }

  handlePaymentClickProxy(...args) {
    this.setState({ paymentStarted: true }, () => {
      setTimeout(() => {
        this.setState({ paymentStarted: false })
      }, 3000)
    })

    this.props.onPaymentClick(...args)
  }

  componentDidMount() {
    this.props.changeReduxFormField('payment', 'termsAccepted', false)
  }

  // eslint-disable-next-line complexity
  render() {
    const {
      amount,
      changeReduxFormField,
      customerRole: {
        registrationNumber,
        monthlyCreditLimitBalance: creditLimit,
        monthlyCreditLimitBalanceFormatted: formattedCreditLimit = '42',
        purchaseAllowed: isPurchaseAllowed,
      },
      editMode,
      isCreditClient,
      paymentMethods,
      sailPackageCode,
      termsAccepted: isTermsAccepted,
      totalPrice,
      reservationId,
      currentReservation,
      locale,
    } = this.props

    const { reservationOwner: { email = '' } = {} } = currentReservation || {}
    const { intl = false, muiTheme } = this.context

    const { vivaWallet } = window.brandProps
    const centPrice = totalPrice * 100

    const customerAccountPaymentAvailable =
      isCreditPaymentAvailable(paymentMethods) && isPurchaseAllowed && registrationNumber
    if (customerAccountPaymentAvailable)
      console.info(`Button for customer account payment is available, company reg num ${registrationNumber}`)

    const handlePaymentClick = () => {
      if (isTermsAccepted) {
        axios
          .post(`/api/payment/${reservationId}/vivaw`, {
            email,
            currency: 'EUR',
            amount: centPrice, // do not trust this amount
          })
          .then(({ redirectUrl }) => {
            if (redirectUrl) window.location.href = redirectUrl
          })
      }
    }
    return (
      <UILayout
        column={window.brandProps.theme === THEME.SAAREMAA || isLiinilaevad}
        borderBottom={getStyle('none', 'solid 1px #bfc3c7')}
        padding="0 0 14px 0"
        sms={xsStyles.wrapper}
      >
        <UILayout
          column
          sms={xsStyles.subWrapper}
          {...(muiTheme.ids.Confirmation &&
            muiTheme.ids.Confirmation.termsWrapper && {
              ...muiTheme.ids.Confirmation.termsWrapper,
            })}
        >
          <UILayout
            row
            padding="0px 15px 15px 25px"
            sms={xsStyles.priceWrapper}
            display-if={!editMode && window.brandProps.theme !== THEME.SAAREMAA && !isLiinilaevad}
          >
            <TotalPrice />
          </UILayout>

          <Alert warning={!isTermsAccepted || !isLiinilaevad} success={isTermsAccepted && isLiinilaevad}>
            <UILayout sms={xsStyles.checkBoxWrapper}>
              <UICheckbox
                labelStyle={styles.label}
                onCheck={(event, value) => changeReduxFormField('payment', 'termsAccepted', value)}
                label={intl.formatMessage(messages.termsQue)}
                iconStyle={styles.labelIcon}
              />
            </UILayout>
            <PaymentTerms muiTheme={muiTheme} locale={locale} sailPackageCode={sailPackageCode} />
          </Alert>
        </UILayout>

        <UILayout
          column
          padding={getStyle('30px 0', window.brandProps.theme === THEME.SAAREMAA ? '0' : '0px 0px 0px 25px')}
          sms={xsStyles.waysWrapper}
          data-testid="payment-ways-wrapper"
        >
          <CustomerAccountPayment
            disabled={!isTermsAccepted || this.state.paymentStarted}
            display-if={customerAccountPaymentAvailable}
            formattedCreditLimit={formattedCreditLimit}
            isCreditLimitEnough={creditLimit >= totalPrice}
            onPaymentClick={this.handlePaymentClickProxy}
          />

          <PaymentMethods
            disabled={!isTermsAccepted || this.state.paymentStarted}
            display-if={Number(amount) > 0 && window.brandProps.theme !== THEME.GAVDOS}
            isCreditClient={isCreditClient}
            onPaymentClick={this.handlePaymentClickProxy}
            paymentMethods={paymentMethods}
          />

          <UILayout
            display-if={Number(amount) > 0 && window.brandProps.theme === THEME.GAVDOS && vivaWallet}
            column
            data-testid="viva-wallet-button"
          >
            <UIButton
              display-if={muiTheme.ids.useSinglePaymentButton}
              disabled={!isTermsAccepted}
              background={muiTheme.ids.buttonStyles && muiTheme.ids.buttonStyles.background}
              onClick={handlePaymentClick}
            >
              <UILayout row center j-flex-center height="100%" width="100%">
                <UIText center translate={messages.pay} size="24px" color="white" margin="0 10px" />
                <Logo backgroundImage={'/images/gavdos/viva-wallet-logo.png'} style={{ height: '26px' }} />
              </UILayout>
            </UIButton>
            <ListItem
              key={'vivaWallet'}
              data-testid="payment-method-viva"
              display-if={!muiTheme.ids.useSinglePaymentButton}
              disabled={!isTermsAccepted}
              onClick={handlePaymentClick}
            >
              <Logo backgroundImage={'/images/gavdos/viva-wallet-logo.png'} />
            </ListItem>
          </UILayout>

          <UILayout display-if={Number(amount) === 0} column data-testid="if-zero-price">
            <UIButton
              id="buttonStyle"
              click={() => this.handlePaymentClickProxy('NONE')}
              maxWidth="100%!important"
              sms={xsStyles.button}
              disabled={!isTermsAccepted || this.state.paymentStarted}
              {...muiTheme.ids.buttonActionStyles}
              {...(muiTheme.ids.buttonActionStyles && { ...muiTheme.ids.buttonActionStyles.nextButton })}
              borderRadius={
                muiTheme.ids.buttonActionStyles &&
                muiTheme.ids.buttonActionStyles.nextButton &&
                muiTheme.ids.buttonActionStyles.nextButton.borderRadius
                  ? muiTheme.ids.buttonActionStyles.nextButton.borderRadius
                  : 'inherit'
              }
            >
              <UILayout
                center
                margin="0 27px"
                lineHeight="30px"
                height="100%"
                width="auto"
                j-flex-space-between
                maxWidth="100%"
              >
                <UILayout
                  column
                  width="auto"
                  style={{ ...(muiTheme.ids.buttonActionStyles && { ...muiTheme.ids.buttonActionStyles.subtitles }) }}
                >
                  <UIText
                    id="buttonLabelTextStyle"
                    align="left"
                    size="18px"
                    opacity="0.5"
                    translate={messages.continue}
                    margin={
                      muiTheme.ids.buttonActionStyles && muiTheme.ids.buttonActionStyles.subtitles
                        ? muiTheme.ids.buttonActionStyles.subtitles.margin
                        : '0'
                    }
                  />
                  <UIText
                    id="buttonTextStyle"
                    align="left"
                    translate={messages.checkout}
                    size="24px"
                    font={
                      muiTheme.ids.buttonActionStyles && muiTheme.ids.buttonActionStyles.titles
                        ? muiTheme.ids.buttonActionStyles.titles.fontFamily
                        : 'inherit'
                    }
                    {...(muiTheme.ids.buttonActionStyles && { ...muiTheme.ids.buttonActionStyles.titles })}
                  />
                </UILayout>
                <UIIcon fill="white" type="selectTicketArrow" />
              </UILayout>
            </UIButton>
          </UILayout>
        </UILayout>
      </UILayout>
    )
  }
}

function mapStateToProps(state) {
  return {
    customerRole: selectors.getCustomerRole(state),
    confirmed: state.reservation.confirmed,
    reservationId: selectors.getCurrentReservationId(state),
    currentReservation: selectors.getCurrentReservation(state),
    termsAccepted: (getFormValues('payment')(state) || {}).termsAccepted,
    paymentMethods: selectors.paymentMethodsSelector(state),
    totalPrice: selectors.getTotalPrice(state),
    locale: getLocale()(state),
  }
}

const mapDispatchToProps = {
  changeReduxFormField: change,
  pay: actions.pay,
  goToPage,
}

const reduxFormConfig = {
  form: 'payment',
  initialValues: {
    termsAccepted: false,
  },
  destroyOnUnmount: true,
}

const PaymentContainer = compose(connect(mapStateToProps, mapDispatchToProps), reduxForm(reduxFormConfig))(Payment)

export default PaymentContainer
